(function() {

    var module = angular.module('app');

    module.directive('termsAndConditions', function() {
        return {
            restrict: 'E',
            templateUrl: '/app/features/termsAndConditions/termsAndConditions.tpl.html',
            scope: {},
            controller: 'termsAndConditionsCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    });

    module.controller('termsAndConditionsCtrl', [
        function() {
            var vm = this;

            
        }
    ]);
}());